import $api from "@/api";

export async function getSpots() {
  return $api.get("/partner/acts");
}
